import {
    Tooltip, TooltipProvider, TooltipTrigger
} from 'shared/components/ui/tooltip';
import {
    cn
} from 'shared/lib/utils';
import {
    Calendar, Filter, User
} from 'lucide-react';
import KBTooltipContent from './KBTooltipContent';
import {
    forwardRef
} from 'react';

const PHDetailWithIcon = forwardRef(({
    icon, label, className, ...props
}, ref) => {
    return (
        <div
            {...props}
            ref={ref}
            className={cn('flex items-center gap-2 font-normal text-xs/[12px] mb-[2px] text-foreground', className)}
        >
            {icon}
            {label}
        </div>
    );
});

export default function ProcessHistoryCard({
    processType, processedBy, processedWhen, processFilter, successPercentage, fileNo
}) {
    const ICON_SIZE = 15;
    return (
        <>
            <div className="rounded-lg border p-2 flex mr-3 border-border bg-card mb-2 last:mb-0">
                <div className="p-2 px-3 flex-shrink-0 border-r flex items-center justify-between border-border text-foreground text-2xl">{processType}</div>
                <div className="text-foreground flex-grow pl-3">
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <PHDetailWithIcon label={processedBy} icon={<User size={ICON_SIZE} />} />
                            </TooltipTrigger>
                            <KBTooltipContent tooltipText={`Processed by: ${processedBy}`} />
                        </Tooltip>
                    </TooltipProvider>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <PHDetailWithIcon label={processedWhen.toLocaleDateString(
                                    'en-US', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })} icon={<Calendar size={ICON_SIZE} />} />
                            </TooltipTrigger>
                            <KBTooltipContent tooltipText={`Processed on: ${processedWhen.toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: true,
                                timeZoneName: 'short'

                            })}`} />
                        </Tooltip>
                    </TooltipProvider>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <PHDetailWithIcon label={processFilter} icon={<Filter size={ICON_SIZE} />} />
                            </TooltipTrigger>
                            <KBTooltipContent tooltipText={`Processed ${processFilter} Files`} />
                        </Tooltip>
                    </TooltipProvider>

                    <PHDetailWithIcon label={fileNo} icon={'File Count: '} />
                </div>
                {successPercentage && <div className="text-sm text-foreground flex items-center">
                    <div>
                        <p className="text-[0.7rem]/[11.2px] font-normal text-center text-foreground line">Successful:</p>
                        <p className="text-2xl/[24px] text-muted-foreground">{successPercentage}%</p>
                    </div>
                </div>}
            </div>

        </>
    );
}